import Vue, { VueConstructor } from "vue";
import ArchNotifications from "@/components/common/ArchNotifications.vue";
import vuetify from "@/plugins/vuetify";

type ArchNotifyType = "error" | "success" | "warning" | "primary";

interface IArchNotify {
  message?: string;
  confirmButtonText?: string;
  color?: ArchNotifyType;
  width?: number | string;
  timeout?: number | string;
  showClose?: boolean;
  useHTML?: boolean;
  textColor?: string;
  action?: IArchNotifyAction;
}

interface IArchNotifyAction {
  text: string,
  onClick: any,
  color?: string
}

declare module "vue/types/vue" {
  interface Vue {
    $archNotify: (args: IArchNotify) => void;
  }
}

export const ArchNotify = (args: IArchNotify) => {
  if(args.color==null){
    args.color = "primary";
  }
  if(args.textColor==null){
    args.textColor = "";
  }
  if(args.showClose===undefined || args.showClose===null){
    args.showClose = true;
    args.confirmButtonText="Close";
  }
  const ComponentClass = Vue.extend(ArchNotifications);
  const instance = new ComponentClass({
    vuetify,
    propsData: args,
  });
  instance.$mount();
  const app = document.getElementById("app")!;
  app.appendChild(instance.$el);
  const timeout = isNaN(Number(args.timeout)) ? 5000 : Number(args.timeout);
  // set timeout to 0 to keep notification always shown unless close clicked
  if (timeout) {
    setTimeout(() => {
      instance.$destroy();
      app.removeChild(instance.$el);
    }, timeout);
  }
};

export default function archNotifyPlugin(Vue: VueConstructor): void {
  Vue.prototype.$archNotify = ArchNotify;
}
